'use client';

import { Avatar } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { useIsMobile } from '@/hooks/use-mobile';
import { useAuthStore } from '@/shared/stores/auth-store';
import { cn } from '@/shared/utils/formatting';
import { getUserDisplay } from '@/shared/utils/user-display';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import * as React from 'react';
import { UserMenuContent } from './UserMenuContent';

export function UserMenu() {
  const user = useAuthStore((s) => s.user);
  const isMobile = useIsMobile();
  const [open, setOpen] = React.useState(false);

  const trigger = (
    <button
      aria-label="User menu"
      className="relative flex size-9 sm:size-10 items-center justify-center rounded-full hover:bg-white/10 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30"
    >
      <Avatar src={user?.dp} alt={getUserDisplay(user)} size="md" fallback={getUserDisplay(user)} />
    </button>
  );

  if (isMobile) {
    return (
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>{trigger}</SheetTrigger>
        <SheetContent
          side="bottom"
          className={cn(
            'rounded-t border-t border-border-default bg-bg-card p-1',
            'max-h-[80dvh] overflow-y-auto'
          )}
        >
          <VisuallyHidden.Root>
            <SheetTitle>User menu</SheetTitle>
          </VisuallyHidden.Root>
          <UserMenuContent onClose={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={8}
        className="w-[300px] rounded border-0 bg-bg-card shadow-xl z-9999"
      >
        <UserMenuContent />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
